<mat-form-field>
  <mat-label>Locatie</mat-label>
  <mat-select [(value)]="selectedLocation" (selectionChange)="onLocationChange()">
    <mat-option *ngFor="let location of locations" [value]="location">
      {{ location }}
    </mat-option>
  </mat-select>
</mat-form-field>
